import {Controller} from "stimulus"
import $ from 'jquery';

import 'select2/dist/css/select2.css'
import 'select2-bootstrap-theme/dist/select2-bootstrap.css'
import reservationContract from "select2"

// require('block-ui/jquery.blockUI')


function formatState(state) {
    if (!state.id) {
        return state.text;
    }

    let number = Math.random() * 255 | 0
    let number1 = Math.random() * 255 | 0
    let number2 = Math.random() * 255 | 0

    let file = '';
    if (state.type.includes('image')) {
        file = `<span style="display: block;width: 100px; height: 100px; background-image: url(${state.file});background-position: center;
                background-size: cover;
                background-repeat: no-repeat; border-radius: 50px; position: relative; overflow: hidden"></span>`
    } else {
        file = `<span style="display: flex;width: 100px; height: 100px; background-color: rgba(${number},${number1},${number2}); border-radius: 50px;
                    position: relative;
                    overflow: hidden;
                    justify-content: center;
                    align-items: center;
                    font-size: 4em;
                    text-transform: uppercase;
                    text-shadow: 3px 3px .25rem rgba(0,0,0,.5);
                    font-weight: bold;">${state.text.charAt(0)}</span>`;
    }


    var template = $(
        `<span style="display: flex; justify-content: flex-start; align-items: center; gap: 25px;">
            ${file}  
            <span style="display: flex;flex-flow: column wrap; justify-content: center; ">
                <p style="grid-area: text;text-transform: uppercase;
                        font-size: 1.3em;
                        font-weight: bold;
                        color: #343434;">${state.text}</p>
                <span style=" display: flex; justify-content: flex-start; gap: 0 25px;">
                    <p style="font-size: .9em;
                                font-weight: 350;
                                color: #959393;">Tamaño: ${state.size}</p>
                    <p style="font-size: .9em;
                                font-weight: 350;
                                color: #959393;">Dimensiones: ${state.dimention}</p>
                    <p style="font-size: .9em;
                                font-weight: 350;
                                color: #959393;">Mime/Type: ${state.type}</p>
                </span>
                
            </span>
        </span>
        `
    );
    return template;
}

// Función para formatear la selección actual
function formatSelection(option) {
    if (!option.id) {
        return option.text; // Si no hay ID, devuelve solo el texto
    }

    // Crear un elemento <span> que contenga la imagen y el texto
    let imageSrc = option.image
    let $selection = $(
        '<span><img src="' + imageSrc + '" class="img-select2" style="width: 3.5rem; height: 3.5rem;"/> ' + option.text + '</span>'
    );

    return $selection;
}

export default class extends Controller {

    connect() {
        $('.c2ec_select').select2({
            theme: "bootstrap",
            language: "es"
            // placeholder: "Seleccione una opción"
        });
        $('.c2ec_select_with_clear').select2({
            theme: "bootstrap",
            language: "es",
            placeholder: "Seleccione una opción",
            allowClear: true
        }).on('select2:select', function () {

            let event = new Event('change', {bubbles: true})
            this.dispatchEvent(event);
        });
        $('.c2ec_select_with_clear_dest').each(function () {
            const $el = $(this);

            // 🚫 evitar reinicializar select2
            if ($el.hasClass("select2-hidden-accessible")) {
                // 🔥 limpiar eventos antes de volver a bindear
                $el.off('select2:select select2:unselect select2:clear');
            } else {
                // inicializar solo una vez
                $el.select2({
                    theme: "bootstrap",
                    language: "es",
                    placeholder: "Seleccione un destino",
                    allowClear: true
                });
            }

            // ✅ bind limpio (solo 1 vez activo)
            $el.on('select2:select select2:clear', function () {
                this.dispatchEvent(new Event('change', { bubbles: true }));
            });
        });

        $('.c2ec_select_multiple').select2({
            theme: "bootstrap",
            language: "es",
            placeholder: "Seleccione una o varias opciones",
            multiple: true
        }).on('select2:select', function () {
            let selectedOptions = $(this).val();
            if (selectedOptions.includes("")) {
                selectedOptions = selectedOptions.filter(option => option !== "");
                $(this).val(selectedOptions).trigger('change');
            }

            let event = new Event('change', {bubbles: true})
            this.dispatchEvent(event);
        });

        let media_select = $('.media_select');
        if (media_select !== undefined && media_select.length > 0) {
            media_select.map((index, elem) => {
                let padre_dataset = elem.dataset;

                $.ajax({
                    url: `${location.origin}/admin/media_galeries/json`,
                    data: {
                        mime: padre_dataset.mime,
                        witout_div: true
                    },
                    type: 'GET',
                    success: function (data) {
                        let rows = [];
                        data.map((el, index) => {
                            let selected = false;
                            if(padre_dataset.hasOwnProperty('value')){
                                if (padre_dataset.value !== '' && (padre_dataset.value === el.reference || padre_dataset.value.includes(el.reference))) {
                                    selected = true
                                }
                            }
                            rows.push({
                                id: el.reference,
                                text: el.name,
                                size: el.size,
                                type: el.mime,
                                file: el.file,
                                dimention: el.dimention,
                                selected: selected
                            })
                        });
                        $(elem).select2({
                            theme: "bootstrap",
                            language: "es",
                            placeholder: "Seleccione una opción",
                            data: rows,
                            templateResult: formatState,
                        }).on('change', function (change) {
                            // alert(change.target.value);
                        })

                    }
                })


            })
        }

        let media_select_mult = $('.media_select_mult');
        if (media_select_mult !== undefined && media_select_mult.length > 0) {
            media_select_mult.map((index, elem) => {
                let padre_dataset = elem.dataset;

                $.ajax({
                    url: `${location.origin}/admin/media_galeries/json`,
                    data: {
                        mime: padre_dataset.mime,
                        witout_div: true
                    },
                    type: 'GET',
                    success: function (data) {
                        let rows = [];
                        data.map((el, index) => {
                            let selected = false;
                            if (padre_dataset.value !== '' && (padre_dataset.value === el.reference || padre_dataset.value.includes(el.reference))) {
                                selected = true
                            }
                            rows.push({
                                id: el.reference,
                                text: el.name,
                                image: el.image,
                                size: el.size,
                                type: el.mime,
                                file: el.file,
                                dimention: el.dimention,
                                selected: selected
                            })
                        });
                        $(elem).select2({
                            theme: "bootstrap",
                            language: "es",
                            placeholder: "Seleccione una opción",
                            data: rows,
                            templateResult: formatState,
                            templateSelection: formatSelection,
                        }).on('change', function (change) {
                            // alert(change.target.value);
                        })
                    }
                })
            })
        }

        // Añadir soporte de altura automática para selects múltiples
        this.setupAutoHeightForMultiSelects()
    }

    setupAutoHeightForMultiSelects() {
        // Esperar un poco para asegurar que Select2 está listo
        setTimeout(() => {
            $('.c2ec_select_multiple').each((index, element) => {
                const $select = $(element)
                const $container = $select.next('.select2-container')
                const $selection = $container.find('.select2-selection--multiple')

                if (!$selection.length) return

                // Aplicar estilos base
                $selection.css({
                    'min-height': '38px',
                    'height': 'auto !important',
                    'max-height': '250px',
                    'overflow-y': 'auto'
                })

                // Función para ajustar altura
                const adjustHeight = () => {
                    const rendered = $selection.find('.select2-selection__rendered')[0]
                    if (rendered) {
                        const height = rendered.scrollHeight + 8 // padding
                        const maxHeight = 250
                        const newHeight = Math.min(Math.max(height, 38), maxHeight)
                        $selection.css('height', newHeight + 'px')
                    }
                }

                // Observar cambios
                const observer = new MutationObserver(() => {
                    setTimeout(adjustHeight, 10)
                })

                observer.observe($selection[0], {
                    childList: true,
                    subtree: true
                })

                // Ajuste inicial
                adjustHeight()
            })
        }, 200)
    }
}